import api from './api';

const marketImportService = {
  /**
   * Upload market data file (CSV/Excel)
   * @param {FormData} formData - Contains the 'marketFile'
   */
  uploadFile: async (formData) => {
    return await api.post('/market_import_data/upload', formData);
  },



  /**
   * Fetch all import logs
   */
  getLogs: async () => {
    return await api.get('/market_import_data/logs');
  },

  /**
   * Get status of a specific import log
   * @param {number|string} id - The log ID
   */
  getLogStatus: async (id) => {
    return await api.get(`/market_import_data/status/${id}`);
  }
};

export default marketImportService;
